export default class SuccessException extends Error { }
